// パフォーマンスメトリックをログに出力する関数
const reportWebVitals = (metric) => {
  console.log(metric); // メトリックをコンソールに出力
};

export default reportWebVitals;